import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import MovieIcon from '@mui/icons-material/Movie';
import CampaignIcon from '@mui/icons-material/Campaign';
import WarningIcon from '@mui/icons-material/Warning';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';

import { getLinkLtik } from 'constants/LTIData';

import classes from './CourseIncludes.module.css';

const CourseIncludes = props => {
  const dataUser = useSelector(state => state.userInfo);
  const dataAcademy = useSelector(state => state.academyInfo);

  let allActivities = 0;
  let completeActivities = 0;
  props.dataCourse.userAditionalTrack.userTrack.map(progress => {
    if (progress.media_play == 2) {
      completeActivities += 1;
    }
    if (progress.media_eval == 2) {
      completeActivities += 1;
    }
    if (progress.media_coeval >= 3) {
      completeActivities += 1;
    }
    if (progress.media_quiz == 2) {
      completeActivities += 1;
    }
  });
  if (props.dataCourse.lessonsCourse.separators) {
    props.dataCourse.lessonsCourse.separators.map(folder => {
      folder.lessons.map(video => {
        allActivities += 1;
        if (video.hasEvaluation) {
          allActivities += 2;
        }
        if (video.idQuiz > 0) {
          allActivities += 1;
        }
      });
    });
  }
  if (props.dataCourse.lessonsCourse.lessons) {
    props.dataCourse.lessonsCourse.lessons.map(video => {
      allActivities += 1;
      if (video.hasEvaluation) {
        allActivities += 2;
      }
      if (video.idQuiz > 0) {
        allActivities += 1;
      }
    });
  }

  // TODO: Eliminar estas lineas cuando el back mande bien la info
  if (completeActivities > allActivities) {
    completeActivities = allActivities;
  }

  const progress = (completeActivities * 100) / allActivities;
  const { t } = useTranslation(['course']);
  return (
    <>
      <div
        className={
          props.accessCourse
            ? classes.productLearnInfoAccessSection
            : classes.productLearnInfoSection
        }
      >
        {getLinkLtik() &&
          dataAcademy.data.integration === 'UVM_LIC_BB' && (
            <>
              {props.ltiData.isConfirm && props.ltiData.isReady && (
                <div className={classes.successMessage}>
                  <p className={classes.title}>
                    {dataUser.data.nombre} ¡felicidades!
                  </p>
                  <div className={classes.infoContainer}>
                    <CampaignIcon className={classes.icon} />
                    <p className={classes.messateText}>
                      Tu calificación se ha enviado a Blackboard y
                      registrado con éxito. Gracias por tu
                      compromiso.
                    </p>
                  </div>
                </div>
              )}
              {!props.ltiData.isConfirm && props.ltiData.isReady && (
                <div className={classes.warningMessage}>
                  <p className={classes.title}>
                    {dataUser.data.nombre}, terminaste tu bloque!
                  </p>
                  <div className={classes.infoContainer}>
                    <WarningIcon className={classes.icon} />
                    <p className={classes.messateText}>
                      Como siguiente paso, obtén tu calificación.
                      Para hacerlo, ingresa al enlace en el menú de
                      Blackboard, ubicado en tu materia, con el
                      nombre “Módulo de acreditación Mayahii”.
                    </p>
                  </div>
                </div>
              )}
              {!props.ltiData && progress === 100 && (
                <div className={classes.warningMessage}>
                  <p className={classes.title}>
                    {dataUser.data.nombre}, terminaste tu bloque!
                  </p>
                  <div className={classes.infoContainer}>
                    <WarningIcon className={classes.icon} />
                    <p className={classes.messateText}>
                      Como siguiente paso, obtén tu calificación.
                      Para hacerlo, ingresa al enlace en el menú de
                      Blackboard, ubicado en tu materia, con el
                      nombre “Módulo de acreditación Mayahii”.
                    </p>
                  </div>
                </div>
              )}
            </>
          )}
        <h2 className={classes.includesTitle}>
          {t('you_will_learn')}
        </h2>
        <p className={classes.includesText}>
          {props.dataCourse.data.descripcion}
        </p>
      </div>
      <div
        className={
          props.accessCourse
            ? classes.productLearnInfoAccessSection
            : classes.productLearnInfoSection
        }
      >
        <h2 className={classes.includesTitle}>
          {t('this_course_include')}
        </h2>
        <div
          className={
            props.accessCourse
              ? classes.productIncludesItemsAccessContainer
              : classes.productIncludesItemsContainer
          }
        >
          <p
            className={
              props.accessCourse
                ? classes.productIncludesAccessItem
                : classes.productIncludesItem
            }
          >
            <MovieIcon className={classes.productIncludeIcon} />{' '}
            <span className={classes.infoIcon}>
              {props.lessons} {t('lessons')}{' '}
              <span className={classes.complementaryText}>
                ({props.hrs} hrs)
              </span>
            </span>
          </p>
          <p
            className={
              props.accessCourse
                ? classes.productIncludesAccessItem
                : classes.productIncludesItem
            }
          >
            <DescriptionOutlinedIcon
              className={classes.productIncludeIcon}
            />{' '}
            <span className={classes.infoIcon}>
              {t('additional_files')} ({props.aditionalMaterial})
            </span>
          </p>
          <p
            className={
              props.accessCourse
                ? classes.productIncludesAccessItem
                : classes.productIncludesItem
            }
          >
            <AttachmentOutlinedIcon
              className={classes.productIncludeIcon}
            />{' '}
            <span className={classes.infoIcon}>
              {t('activities')}{' '}
              <span className={classes.complementaryText}>
                ({props.activities})
              </span>
            </span>
          </p>
          <p
            className={
              props.accessCourse
                ? classes.productIncludesAccessItemSpecial
                : classes.productIncludesItem
            }
          >
            <figure className={classes.iconIncludesContainer}>
              <img
                className={classes.img}
                src="https://d1g6c01s9ssd7h.cloudfront.net/img/consulta_diploma.png"
              />
            </figure>
            <span className={classes.infoIcon}>
              {t('course_diploma')}
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

CourseIncludes.propTypes = {
  // eslint-disable-next-line react/require-default-props
  dataCourse: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  aditionalMaterial: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  activities: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  hrs: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  ltiData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  accessCourse: PropTypes.bool
};

export default CourseIncludes;
